/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useActions } from '../../providers/actions-provider/actions.context';
import { useStore } from '../../../store';
import { IAssetTypes } from '../../../store/modules/asset/i-asset';
import capitalize from '../../../utils/capitalize';
import { IFormFields } from '../../lib/field-edit-form/field-edit-form';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useAssetsData = () => {
  const { assetActions } = useActions();
  const { assetTypes } = useStore();
  const { push } = useHistory();
  const [finalAssets, setFinalAssets] = useState<Array<IAssetTypes>>([]);
  const [copyAssetTypes, setCopyAssetTypes] = useState<Array<IAssetTypes>>([]);
  const [columns, setColumns] = useState<Array<string>>([]);
  const [filters, setFilters] = useState<Array<IFormFields>>([]);

  useEffect(() => {
    assetActions.getAssetTypes(10);
  }, []);

  const camel_to_space = (str: string) => (
    str[0].toUpperCase() + str.slice(1, str.length).replace(/[A-Z]/g, (letter) => ` ${letter.toLowerCase()}`)
  );

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    initialAssetTypes();
  }, [assetTypes]);

  const initialAssetTypes = () => {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const finalAssets: Array<IAssetTypes> = JSON.parse(JSON.stringify(assetTypes.data));
    // eslint-disable-next-line @typescript-eslint/no-shadow
    let columns: Array<string> = [];
    if (finalAssets.length > 0) {
      columns = Array.from(new Set(finalAssets.map((el) => Object.keys(el)).flatMap((el) => el)));
      setFilters(columns.filter((column) => column !== 'id' && column !== 'tenant').map((column) => ({
        name: camel_to_space(column), value: column,
      })));
    } else {
      columns = [];
    }
    setFinalAssets(finalAssets);
    setColumns(columns);
    setCopyAssetTypes(finalAssets);
  };

  const assetsFilters = assetTypes.fields?.map((el, i) => {
    if (assetTypes.headers) {
      return {
        field: el,
        header: assetTypes.headers[i],
      };
    }
  });

  const initialFilter = {
    field: '',
    type: '',
    value: '',
  };

  return useMemo(() => ({
    data: {
      count: assetTypes.count,
      fields: assetTypes.fields || [],
      headers: assetTypes.headers || [],
      loading: assetTypes.loading,
      assetsFilters,
      rows: copyAssetTypes.map((asset: IAssetTypes, i: number) => ({ ...asset, key: i })),
      columns: columns.map((asset: string) => ({
        key: asset,
        title: capitalize(asset),
        dataIndex: asset,
        sorter: (a: IAssetTypes, b: IAssetTypes) => {
          if (typeof (a[asset]) === 'string') {
            return a[asset].localeCompare(b[asset]);
          }
          return a[asset] - b[asset];
        },
      })),
    },
    filters,
    onClearFilters: () => [initialFilter],
    initialFilter,
    onClick: (id: number): void => {
      push(`asset-data/${id}`);
    },
    onSearch: (e: string, currentFilter: string) => {
      const filteredAssets = finalAssets.filter((finalAsset) => {
        const copyAsset = JSON.parse(JSON.stringify(finalAsset));
        if (!currentFilter || !copyAsset[currentFilter]) {
          return finalAsset;
        }
        if (copyAsset[currentFilter].toLowerCase().indexOf(e.toLowerCase()) > -1) {
          return finalAsset;
        }
        return null;
      });
      setCopyAssetTypes([...filteredAssets]);
    },
  }), [assetTypes, finalAssets, copyAssetTypes]);
};

export default useAssetsData;
